import {Component, Input} from '@angular/core';
import {AppConstants} from '../../app-constants';
import {IonIcon, IonRow} from '@ionic/angular/standalone';

@Component({
  selector: 'app-pin-form',
  imports: [IonRow, IonIcon],
  templateUrl: './pin-form.component.html',
  styleUrls: ['./pin-form.component.scss']
})
export class PinFormComponent {
  @Input() pin = AppConstants.EMPTY_STRING;
}
